import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import CancelIcon from "@mui/icons-material/Cancel";

export interface IProps {
  /**
   * ボタンが押された場合に呼び出されます
   */
  onClick?: () => void;
}

export default function CancelButton(props: IProps) {
  const [open, setOpen] = useState(false);
  function handleMouseOver() {
    if (open === false) {
      setOpen(true);
    }
  }
  function handleMouseLeave() {
    if (open === true) {
      setOpen(false);
    }
  }
  return (
    <Tooltip title="cancel" arrow placement="bottom" open={open}>
      <IconButton
        aria-label="cancel"
        onClick={props.onClick}
        onMouseOver={handleMouseOver}
        onMouseLeave={handleMouseLeave}
      >
        <CancelIcon />
      </IconButton>
    </Tooltip>
  );
}
